const itemActionListStyle = {
  '.navigationItem': {
    color: '#006fcf !important',
    paddingLeft: '15px !important',
  },
  '.navigation': {
    width: 'fit-content',
    minWidth: '100%',
  },
};

export default itemActionListStyle;
